<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="tabs-container">
      <el-tabs
        v-model="activeTabName"
        type="card"
        style="width:100%"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          :label="$t('baseInfo.seaport.tabPort.tabName')"
          name="port"
        >
          <a-port ref="port" />
        </el-tab-pane>
        <el-tab-pane
          :lazy="true"
          :label="$t('baseInfo.seaport.tabAmsPort.tabName')"
          name="amsPort"
        >
          <a-ams-port ref="ams-port" />
        </el-tab-pane>
      </el-tabs>
      <div
        v-show="loading"
        style="position: fixed;z-index: 9999;height: 100%;width: 100%;background-color: #2d3a4b22;
      display: flex;justify-content: center;align-items:center"
      >
        <svg-icon
          icon-class="loading-bars"
          style="font-size:60px;"
        />
      </div>
    </div>
  </div>
</template>
<script>
import AAmsPort from '@/views/cargo/v0/Information/components/aAmsPort'
import APort from '@/views/cargo/v0/Information/components/aPort'

export default {
  name: 'AirPort',
  components: { APort, AAmsPort },
  filters: {},
  data() {
    return {
      loading: false,
      activeTabName: 'port'
    }
  },
  computed: {

  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleTabClick() {
    },
    onReady(params) {
    }
  }
}
</script>
